import React from 'react';
import PropTypes from 'prop-types';
import ReactUtils from '../../../packages/react-utils/react-utils.js';
import '@flixbus/honeycomb-icons-react';
import '../../../packages/props-utils/prop-types.js';
import { useLegacyAutocompleteContext } from '../legacy-autocomplete.context.js';
import { useLegacyAutocompleteInputContext } from './legacy-autocomplete-input.context.js';
import Input from '../../../components/input/input.js';

/**
 * @deprecated This component is deprecated since v12.0.0. It is being kept to ease the transition
 * to the new [Autocomplete controller](/#/Controllers/Autocomplete). If you are using this
 * component, please consider migrating to the new one, as it is easier to use, has more features
 * and has less bugs.
 */
function LegacyAutocompleteInput(props) {
  const {
    containerId,
    focusedOption,
    isMultiselect
  } = useLegacyAutocompleteContext();
  const {
    optionsListVisible,
    onChange = () => null,
    value,
    inputRef
  } = useLegacyAutocompleteInputContext();
  const handleOnChange = event => {
    onChange(event);
    if (props.onChange) {
      props.onChange(event);
    }
  };
  return /*#__PURE__*/React.createElement(Input, Object.assign({
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-autocomplete": "list",
    "aria-controls": "".concat(containerId, "-listbox"),
    "aria-expanded": optionsListVisible,
    "aria-describedby": isMultiselect ? "autocomplete-selected-list-for-".concat(containerId) : ''
  }, optionsListVisible && focusedOption >= 0 && {
    'aria-activedescendant': "".concat(containerId, "-option-").concat(focusedOption)
  }, {
    value: value
  }, props, {
    innerRef: node => {
      ReactUtils.assignInnerRefWithComponentRef(node, props.innerRef, inputRef);
    },
    onChange: handleOnChange
  }));
}
LegacyAutocompleteInput.displayName = 'LegacyAutocompleteInput';
LegacyAutocompleteInput.propTypes = {
  extraClasses: PropTypes.string
};

export { LegacyAutocompleteInput as default };
